import { Injectable } from '@angular/core';
import { firstValueFrom, fromEvent, Observable, takeUntil } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AXLoginRequest, AXLoginResponse, PortalLoginRequestBody, PortalLoginResponse } from '../Models/portal-login';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  OBPortalSvcURL = '';
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  private http!: HttpClient;
  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient) {
      this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    }

  public GetPortalLogin(bookingCode?: string, lastname?: string, loyaltynumber?: string): Observable<PortalLoginResponse> {
    const portalLoginInfo = new PortalLoginRequestBody(bookingCode, lastname, loyaltynumber);
    return this.httpClient.post<any>(`${this.OBPortalSvcURL}GetPortalLogin`, portalLoginInfo, { headers: this.headers });
  }

  public AXLogin(bookingCode: string, surname: string): Observable<AXLoginResponse> {
    const body: AXLoginRequest = { BookingCode: bookingCode, Surname: surname };
    return this.httpClient.post<AXLoginResponse>(
      `${this.OBPortalSvcURL}AX/login`,
      body,
      { headers: this.headers }
    );
  }

  public async GetPortalLoginAsync(bookingCode: string, lastname: string, loyaltynumber: string, abortControl: AbortController): Promise<any> {
    const portalLoginInfo = new PortalLoginRequestBody(bookingCode, lastname, loyaltynumber);
    const aborted$ = fromEvent(abortControl.signal, 'abort');
    return await firstValueFrom(
      this.httpClient
        .post<any>(`${this.OBPortalSvcURL}GetPortalLogin`, portalLoginInfo)
        .pipe(takeUntil(aborted$))
      );
  }
  public RecordAccess(
    login: string | undefined,
    status: boolean | undefined,
    IPAddress: string | undefined,
    type: string | undefined,
    route: string | undefined
  ): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const PortalLoginInfo: JSON = <JSON>(<unknown>{
      login: login,
      status: status,
      IPAddress: IPAddress,
      type: type,
      route: route,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'RecordAccess',
      JSON.stringify(PortalLoginInfo),
      { headers: headers }
    );
  }
}
